module.exports = __webpack_public_path__ + "static/media/1.6f93766f.jpg";